"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackWorkspaceActivated = trackWorkspaceActivated;
exports.trackSessionStarted = trackSessionStarted;
exports.trackChatCreated = trackChatCreated;
exports.trackDocGenerated = trackDocGenerated;
exports.trackDocRefined = trackDocRefined;
exports.trackPlanStarted = trackPlanStarted;
exports.trackStepCompleted = trackStepCompleted;
exports.trackPlanDone = trackPlanDone;
exports.trackError = trackError;
exports.trackCommandInvoked = trackCommandInvoked;
/** Loom activated in a workspace — reach/engagement denominator. */
function trackWorkspaceActivated(t) {
    t.track('workspace_activated');
}
/** A new session began — retention anchor ("do they return"). */
function trackSessionStarted(t) {
    t.track('session_started');
}
/**
 * A new chat (the thinking surface) was opened — the loop's entry point. Answers
 * "is the collaboration medium actually used?". Fired on chat *creation* only, not
 * per reply: appends are high-volume and would swamp the signal.
 */
function trackChatCreated(t) {
    t.track('chat_created');
}
/** A structured doc was generated (the {generate} phase). */
function trackDocGenerated(t, type) {
    t.track('doc_generated', { type });
}
/** A structured doc was refined (the {refine} phase). */
function trackDocRefined(t, type) {
    t.track('doc_refined', { type });
}
/** A plan entered `implementing` — the loop was entered. */
function trackPlanStarted(t) {
    t.track('plan_started');
}
/** A plan step was completed — the core loop heartbeat. */
function trackStepCompleted(t, hadError = false) {
    t.track('step_completed', { had_error: hadError });
}
/** A plan reached `done` — loop closure / the success event. */
function trackPlanDone(t) {
    t.track('plan_done');
}
/**
 * An operation failed — where people stall. `operation` and `errorClass` must be
 * fixed identifiers (use-case name, error constructor name), never a message
 * carrying user/document content.
 */
function trackError(t, operation, errorClass) {
    t.track('error', { operation, error_class: errorClass });
}
/** A tool / command fired — coarse "which capabilities are used". */
function trackCommandInvoked(t, command) {
    // loom_validate runs constantly (the extension's diagnostics + refresh drive it),
    // so its command_invoked events swamp the signal — and it carries no workflow
    // meaning. Drop it at the single emit point, which covers both the CLI and the
    // MCP-tool paths.
    if (command === 'loom_validate')
        return;
    t.track('command_invoked', { command });
}
